import { type FC } from 'react';
import { Badge } from '@mantine/core';
import { formatOrder, type PayoutOrder, PayoutOrderStatus } from '~/entities/payout';
import { OrderStatusBadge } from './components';

interface OrderDisplayStatusBadgeProps {
    order: PayoutOrder;
    fullWidth?: boolean;
}

export const OrderDisplayStatusBadge: FC<OrderDisplayStatusBadgeProps> = ({ order, fullWidth = false }) => {
    if (order.status === PayoutOrderStatus.STATUS_SPLIT) {
        return (
            <Badge
                variant='dot'
                fullWidth={fullWidth}
                color='violet.6'
            >
                {formatOrder.status(order.status)}
            </Badge>
        );
    }

    return (
        <OrderStatusBadge
            status={order.pubicStatus}
            fullWidth={fullWidth}
        />
    );
};
